var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":"","color":_vm.scaleColor(_vm.value || '-')}},[_c('k-text',{staticClass:"text-capitalize",attrs:{"text":_vm.value || '-'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }